import { FC, useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import AppContext from '../../../store/appContext';
import { Props } from '../../../interfaces/interfaces';
import { useParams, useSearchParams } from 'react-router-dom';
import Filters from '../../layout/Filters/Filters';
import SurveyBasic from '../../layout/SurveyBasic/SurveyBasic';
import Paginator from '../../ui/Paginator/Paginator';

const Surveys: FC<Props> = (props): JSX.Element => {
  const { getFilters, getSurveys, getWhoAmI, limit, oper, surveys, totalSurCount, unassigned } =
    useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(1);

  // Get parameters from URL
  const [searchParams] = useSearchParams();
  const regNum = searchParams.get('regNum') || '';

  // fetchin params from urls
  const { priority } = useParams();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getWhoAmI(), []);

  useEffect(() => {
    getFilters();
    if (priority !== '') {
      getSurveys(limit, (currentPage - 1) * limit, priority, regNum, '', '', '', oper);
    } else {
      getSurveys(limit, (currentPage - 1) * limit, '', regNum, '', '', '', oper);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, priority, oper, currentPage, unassigned, regNum]);

  let result = [
    <Col key={`99999999`} className="d-flex justify-content-center">
      <Spinner animation="border" />
    </Col>,
  ];
  let generatedSurveys: JSX.Element[] = [];
  if (surveys) {
    generatedSurveys = surveys.map((survey) => {
      return (
        <Col key={survey?.reg_num} xs={12}>
          <SurveyBasic fields={survey} />
        </Col>
      );
    });
    if (generatedSurveys.length > 0) {
      result = generatedSurveys;
    } else {
      result = [
        <Col key={`9999999`}>
          <h3 className="mt-5 text-center">Nic jsem nenašlo, pardon</h3>
        </Col>,
      ];
    }
  }

  return (
    <section className="top">
      <h1 className="px-3 mb-4 display-5 text-center">{props.header}</h1>
      <Container>
        <Filters />
        <Row className="mb-3">
          <Col>
            <Paginator
              totalCount={totalSurCount!}
              itemsPerPage={limit}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </Col>
        </Row>
        <Row className="mb-3">{result}</Row>
        <Row className="mb-5">
          <Col>
            <Paginator
              totalCount={totalSurCount!}
              itemsPerPage={limit}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Surveys;
